import { useMutation } from '@tanstack/react-query'
import { LoginInputType } from '../../pages/auth/LoginPage'
import { APIErrorType, publicRequestV2 } from '../../utils/helper/axiosRequest'
import { ApiEnum } from './interface'
import { getExceptionPayload } from '../../utils/helper/errorResult'
import { RemoveCookie, SetCookie } from '../../utils/customHook/useCookies'

type SignInType = {
  extendSuccess: () => void
}

export const useLogin = ({ extendSuccess }: SignInType) =>
  useMutation({
    mutationFn: async (body: LoginInputType) => {
      const response = await publicRequestV2.post(ApiEnum.SIGN_IN, body)
      return response.data
    },
    onSuccess: async (response) => {
      const accessToken = response.data.accessToken
      SetCookie('token', accessToken)
      SetCookie('refreshToken', response.data.refreshToken)
      extendSuccess()
    },
    onError(error: APIErrorType) {
      RemoveCookie('token')
      return getExceptionPayload(error)
    },
  })
